<template>    
    <IonPage>
        <IonContent fullscreen padding="true">

            <AInesMessage v-if="false" :text-content='"Test **bold** _italic_ ~~strike~~ \n * List1\n * List2\n\n http://www.google.de"' />

            <CalendarDetail v-if="false" v-model="showModalDate" />

            <template v-if="false">
                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton(date.getToday())"
                    :day="{availability: {date:date.getToday(), constraints: [], shifts: [{type: ShiftType.Fd, begin: datetime.addHours(datetime.getNow(), 2), until: datetime.addHours(datetime.getNow(), 16)}], additionalAvailabilityCoordinates:[]}, moreMoreDemands:[]}"
                ></Day>

                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-01')"
                    :day="{availability: {date:'2025-01-01', constraints: [], shifts: [{type: ShiftType.Fd, begin: '2025-01-01T06:00', until: '2025-01-01T14:00'}], additionalAvailabilityCoordinates:[]}, moreMoreDemands:[]}"
                ></Day>
                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-02')"
                    :day="{booking: {begin:'2025-01-02T12:00', until:'2025-01-02T18:00', shiftType: ShiftType.Sd, jobsite:jobsiteMock, comment: {text:'lorem ipsom dsdosdlsanfsd dsnflkdsnfdksfd dsfsdgf', lastUpdated: datetime.getNow()}} as Booking}"
                ></Day>
                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-03')"
                    :day="{absence: {type: AbsenceType.Timeoff} as Absence}"
                ></Day>
                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-04')"
                    :day="{moreMoreDemands: [{shiftType: ShiftType.Fd, jobsite:jobsiteMock}] as Demand[]}"
                ></Day>
                <Day
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-05')"
                    :day="{wishDemands: [{shiftType: ShiftType.Fd, jobsite:jobsiteMock}] as Demand[]}"
                ></Day>
                <Day
                    v-if="false"
                    @click:date="(d) => showModalDate = d.dateId"
                    :calendarDateSingleton="getCalendarDateSingleton('2025-01-06')"
                    :propsLoading="true"
                ></Day>
                <CalendarDetail
                    v-if="false"
                    v-model="showModalDate"
                ></CalendarDetail>
            </template>

            <CalendarDetail
                v-if="false"
                :modelValue="'2025-10-31'"
            />

            <AbsenceEditor v-if="false" date="2025-03-08" :absence="{date:'2025-03-08', type: AbsenceType.Sickness}"/>


            <!-- RICH RESPONSES -->

            <TimesheetList
                v-if="false"
                :init-data="1"
            />
            <JobsiteList
                v-if="false"
                :init-data="AInesJobsiteListType.Favorite"
            />

                <!--{listType:, selectable: true}-->
            <PlanningStatus
                v-if="false"
                init-data="2025-03-01"
            />

            <AvailabilityConstraintEditor
                v-if="false"
                v-model="showModal"
                :date="'2025-01-01'"
                :availability="{date:'2025-01-01', constraints: [], shifts: [{type: ShiftType.Fd, begin: '2025-01-01T06:00', until: '2025-01-01T14:00'}]}"
            />

            <AvailabilityAbsenceEditor
                v-if="false"
                :availability="undefined"
                :absence="undefined"
                :date="'2025-01-01'"
            />

            <PlanningStatus
                v-if="false"
                init-data="2025-11-01"
            />
            <MonthCalendar
                v-if="false"
                init-data="2024-09-01"
            />
            <WeekCalendar
                v-if="false"
                init-data="2024-10-01"
            />
            <DayCalendar
                v-if="false"
                init-data="2025-10-17"
            />

            <DayVue
                v-if="false"
                :calendarDateSingleton="getCalendarDateSingleton('2026-04-16')"
                :day="day"
                :propsLoading="false"
                :key="getCalendarDateSingleton('2026-04-16').type + getCalendarDateSingleton('2026-04-16').date"
            />

            <RegisterBookingSummary
                v-if="false"
                :init-data="{jobsite:'Station 3', shift: ShiftType.Fd, dates: ['2024-10-01']}"
            />
            <JobsiteSearch
                v-if="false"
                init-data="WMK-S4"
            />

            <!-- Booking Suggestions -->
            <IonButton v-if="false" @click="bookingSuggestionModalOpen = true">Open BookingSuggestionListModal</IonButton>
            <BookingSuggestionListModal
                v-if="false"
                v-model="bookingSuggestionModalOpen"
            />
            <BookingSuggestionListRR
                v-if="false"
                :init-data="{withdrawerId: null, employeeIds: undefined}"
            />

            <InitCandidatePromotion v-if="false" :useLastChatMessageAsIntroMessage="false" :open-modal-immediately="false"/>

            <AutopilotJobsitePreferences v-if="false" init-data="2025-03-01" />


            <CandidateMissingJobsiteType v-if="false" :init-data="'1:1 Betreuung'"/>
            <DemandList v-if="false" :init-data="[571685, 505040, 505036, 580370, 544811, 580380, 581603, 581604, 534884, 547170, 547171, 581615]"/>

            <!-- DETAIL MODALS  -->

            <Modal v-if=false v-model="showModal" title="Detail" class="no-padding-left no-padding-right">
                <AvailabilityAbsenceEditor
                    v-if="false"
                    :availability="undefined"
                    :absence="undefined"
                    :date="undefined"
                ></AvailabilityAbsenceEditor>
                <CalendarDetail
                    v-if="false"
                    :date-id="undefined"
                ></CalendarDetail>
                <RegisterBookingSummary
                    v-if="false"
                    :init-data="{jobsiteSearchString:'Station 3', dates:['2024-11-10'], shift:ShiftType.Fd}"
                ></RegisterBookingSummary>

            </Modal>


            <!-- PROCESS MODALS  -->


<!--            <Modal v-if=false v-model="showModal" title="Prozess">-->
<!--                <RegisterBookingTopSheet-->
<!--                    v-if="false"-->
<!--                    :init-data="undefined"-->
<!--                ></RegisterBookingTopSheet>-->
<!--            </Modal>-->

            <StartPlanningMonth
                v-if="false"
                :month="'2025-06-01'"
                v-model="showModal"
            />


            <PlanningMonthSettingsModal
                v-if="false"
                :month="'2025-06-01'"
                v-model="showModal"
            />

            <CalendarModal
                v-if="false"
                v-model="showModal"
                initial-date="2026-04-17"
                min-date="2026-04-01"
                max-date="2026-04-30"
                :showPlanningStatus="false"
            ></CalendarModal>

            <JobsiteDetails
                v-if="false"
                v-model="jobsiteId"
            ></JobsiteDetails>



            <JobsiteSearchModal
                v-if="false"
                v-model="showModal"
            />

            <JobsiteDemandDayDetail
                v-if="false && !!jobsite"
                :jobsite="jobsite"
                v-model="showModal"
                date="2025-11-01"
                :showJobsiteDetailModalLink="true"
            />
            <JobsiteDemand
                v-if="false"
                v-model="jobsite"
            />
            <DemandBrowserJobsiteList
                v-if="false"
                :init-data="{jobsiteIds:[jobsiteId], dateRange: {}, shiftSelection: ['FD']}"
            />

            <RegisterBookingModal
                v-if="false"
                v-model="showModal"
            />

            <AInesObjectivesList
                v-if="false"
            />

            <JobsitePickerModal
                :jobsites="[jobsiteMock, jobsiteMock]"
                v-if="false"
                v-model="showModal"
            />
            <JobsiteManager
                v-if="false"
                :model-value="showModal"
            />
            <JobsiteSearchModal
                v-if="false"
                :model-value="showModal"
            />

            <DemandBrowserJobsiteList
                v-if="false"
                :init-data='{"jobsiteIds":[81,169,80,64,1869,1908,1256,9,162,171,27,8,310,1753,4,1483,1785,1787,1469,1408,1319,1356,2032,1287,1699,606,581,583,424,539,59,190,1286,1404,1268,2034,338,1334,66,1306,1996],"shiftSelection":["FD","SD","ND"],"dateRange":{"begin":"2025-10-16"},"spotlight":"dienstvolumen"}'
            />
            <DemandBrowserJobsiteList
                v-if="false"
                :init-data='{"jobsiteIds":[1, 2, 3, 31, 34, 35, 36],"shiftSelection":["FD","SD","ND"],"dateRange":{"begin":"2025-10-16"},"spotlight":"dienstvolumen"}'
            />

            <DemandBrowserJobsiteList
                v-if="false"
                :init-data='{"jobsiteIds":[137],"shiftSelection":["FD","SD","ND"],"dateRange":{"begin":"2025-10-16"},"spotlight":"dienstvolumen"}'
            />

            <DemandBrowserOffeneDiensteList
                v-if="false"
                :init-data='{"jobsiteId": 137, "coordinates": [{ "date": "2025-12-20", "shift": "FD" }]}'
                :render-shifts="false"
                expandable
            />

            <TimesheetProcess
                v-if="false"
                v-model="showModal"
                :selected-jobsite-id="jobsiteId"
                v-on:done="(a,b,c) => { debugger }"
            />

            <ShiftTimes
                v-if="false"
            ></ShiftTimes>

            <MonthKPIExcessDetails v-if="true" :selected-month="'2026-03-01'" />
            <MonthKPIOverview v-if="true" selected-month="2026-03-01" />

            <MonthKPIAZK v-if="false" selectedMonth="2026-03-01"/>
            <MonthKPIRevenueAndExcessContribution v-if="false" selected-month="2026-03-01"/>
            <MonthKPICompany v-if="false" selected-month="2026-03-01"/>


            <AutopilotWorktimePreferences
                v-if="false"
                v-model="showModal"
                :month="'2025-04-01'"
            />
            <!-- #Twinki -->
            <AutopilotWizardSickness
                v-if="false"
                v-model="showModal"
                :initial-month="'2026-03-01'"
                :showMostRecentAInesMessage=true
            />
            <!-- #Twinki -->
            <AutopilotWizardVacation
                v-if="false"
                v-model="showModal"
                :month="'2025-04-01'"
            />

            <AvailabilityConstraintEditorModal
                v-if="false"
                v-model="showModal"
                :containing-availability="{date:'2025-01-01', constraints: [], shifts: [{type: ShiftType.Fd, begin: '2025-01-01T06:00', until: '2025-01-01T14:00'}]}"
            />


        </IonContent>
    </IonPage>
</template>

<script setup lang="ts">
// @ts-nocheck
import {IonContent, IonPage, IonButton} from '@ionic/vue';
import RegisterBookingSummary from "@/views/Chat/RichResponses/RegisterBookingSummary.vue";
import {
    Absence,
    AbsenceType,
    AInesJobsiteListType,
    Booking,
    Demand,
    Jobsite,
    ShiftType
} from "@/graphql/generated/graphql";
import JobsiteList from "@/views/Chat/RichResponses/JobsiteList.vue";
import PlanningStatus from "@/views/Chat/RichResponses/PlanningStatus.vue";
import WeekCalendar from "@/views/Chat/RichResponses/WeekCalendar.vue";
import DayCalendar from "@/views/Chat/RichResponses/DayCalendar.vue";
import MonthCalendar from "@/views/Chat/RichResponses/MonthCalendar.vue";
import Modal from "@/components/Modal.vue";
import {Ref, ref} from "vue";
import JobsiteSearch from "@/views/Chat/RichResponses/JobsiteSearch.vue";
import TimesheetList from "@/views/Chat/RichResponses/TimesheetList.vue";
import JobsiteDetails from "@/views/JobsiteDetails.vue";
import AvailabilityAbsenceEditor from "@/components/AvailabilityAbsenceEditor.vue";
import CalendarDetail from "@/views/CalendarDetail/CalendarDetail.vue";
import StartPlanningMonth from "@/views/components/Planning/StartPlanningMonth.vue";
import CalendarModal from "@/views/Calendar/CalendarModal.vue";
import InitCandidatePromotion from "@/views/Chat/RichResponses/InitCandidatePromotion.vue";
import AutopilotJobsitePreferences from "@/views/Chat/RichResponses/AutopilotJobsitePreferences.vue";
import CandidateMissingJobsiteType from "@/views/Chat/RichResponses/CandidateMissingJobsiteType.vue";
import DemandList from "@/views/Chat/RichResponses/DemandList.vue";
import DemandBrowserJobsiteList from "@/views/Chat/RichResponses/DemandBrowserJobsiteList.vue";
import Day from "@/views/Calendar/Day.vue";
import DayVue from "@/views/Calendar/Day.vue";
import {getCalendarDateSingleton} from "@/helper/calendar/calendarDateSingleton";
import PlanningMonthSettingsModal from "@/views/components/Planning/PlanningMonthSettingsModal.vue";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import JobsiteSearchModal from "@/views/components/JobsiteSearchModal.vue";
import RegisterBookingModal from "@/views/components/RegisterBookingModal.vue";
import AInesObjectivesList from "@/views/Chat/AInesObjectivesList.vue";
import AutopilotWorktimePreferences from "@/views/components/Planning/AutopilotWorktimePreferences.vue";
import AbsenceEditor from "@/components/AbsenceEditor.vue";
import JobsitePickerModal from "@/views/components/JobsitePickerModal.vue";
import {JSONParser} from "@streamparser/json";
import AutopilotWizardSickness from "@/views/components/Planning/AutopilotWizardSickness.vue";
import AutopilotWizardVacation from "@/views/components/Planning/AutopilotWizardVacation.vue";
import JobsiteManager from "@/views/Settings/JobsiteManager.vue";
import ShiftTimes from "@/views/Chat/RichResponses/ShiftTimes.vue";
import MonthKPI from "@/views/Chat/RichResponses/MonthKPI.vue";
import MonthKPIAZK from "@/views/components/MonthKPI/section/MonthKPIAZK.vue";
import AvailabilityConstraintEditorModal from "@/components/AvailabilityConstraintEditorModal.vue";
import AvailabilityConstraintEditor from "@/components/AvailabilityConstraintEditor.vue";
import TimesheetProcess from "@/views/Timesheet/TimesheetProcess.vue";
import JobsiteDemand from "@/views/JobsiteDemand.vue";
import {computedAsync} from "@vueuse/core";
import {getJobsite} from "@/helper/jobsite";
import DemandBrowserOffeneDiensteList from "@/views/Chat/RichResponses/DemandBrowserOffeneDiensteList.vue";
import JobsiteDemandDayDetail from "@/views/JobsiteDemandDayDetail.vue";
import {fetchDayForDate} from "@/helper/day";
import AInesMessage from "@/views/Chat/AInesMessage.vue";
import BookingSuggestionListModal from "@/views/Chat/BookingSuggestionListModal.vue";
import BookingSuggestionListRR from "@/views/Chat/RichResponses/BookingSuggestionListRR.vue";
import datetime from "@/helper/datetime/datetime";
import date from "@/helper/datetime/date";
import MonthKPIRevenueAndExcessContribution
    from "@/views/components/MonthKPI/section/MonthKPIRevenueAndExcessContribution.vue";
import MonthKPICompany from "@/views/components/MonthKPI/section/MonthKPICompany.vue";
import MonthKpiOverview from "@/views/components/MonthKPI/MonthKPIOverview.vue";
import MonthKPIExcessDetails from "@/views/components/MonthKPI/MonthKPIExcessDetails.vue";
import MonthKPIOverview from "@/views/components/MonthKPI/MonthKPIOverview.vue";

date.getToday()
//////////////////////// BEGIN DEMO ////////////////////////

let parser;
let currentChunk = "";

const reInitParser = () => {

    const newParser = new JSONParser();

    // Log every complete value that the parser emits
    newParser.onValue = ({value, key}) => {
        // console.log("Key:", key);
        // console.log("Value:", value);
    };

    newParser.onToken = ({ value}) =>
    {
        // console.log("value ", value)
    }

    newParser.onError = (err) => {
        if(err.message.startsWith('Unexpected "{"')){
            parser = reInitParser()
            parser.write(currentChunk)
        }
    }

    return newParser
}

parser = reInitParser()

const day = ref()

const loader = async () => {
    day.value = await fetchDayForDate('2025-10-17')
}

loader()

// Our concatenated JSON string with two JSON objects
const data = '{"a":1} {"b":2}';

// To simulate a streaming scenario, split the data into chunks
const chunks = [
    data.substring(0, 5), // e.g. '{"a":'
    data.substring(5, 7), // e.g. '1}'
    data.substring(7)     // e.g. '{"b":2}'
];

// Function to simulate asynchronous streaming of chunks
function simulateStream(chunks, parser, index = 0) {
    if (index < chunks.length) {
        currentChunk = chunks[index]
        // console.log("Writing chunk:", currentChunk);
        // Write the current chunk to the parser
        parser.write(currentChunk);
        // Wait 500ms before sending the next chunk
        setTimeout(() => simulateStream(chunks, parser, index + 1), 500);
    }
}

// Start the simulated stream
simulateStream(chunks, parser);

//////////////////////// END DEMO ////////////////////////

const showModal: Ref<boolean> = ref(true);
const showModalDate: Ref<kapitelDateString|undefined> = ref('2026-04-18');
const jobsiteId = ref(34)
const bookingSuggestionModalOpen = ref(false)

const jobsiteMock = {id: 137, name: 'Stationsbezeichnung 1', abbreviation: 'Station 1', client: { name : 'Kundenbezeichnung', abbreviation: 'K'}} as Jobsite
const jobsite = computedAsync(async () => await getJobsite(jobsiteId.value))
</script>

<style lang="scss" >
</style>
